// Pure logic for the Want Overlap pill (spec 2026-09-21, CONTEXT.md "Want
// Overlap"): copy, the pill-vs-button decision, and the claimed-binder
// annotation the Propose Trade modal renders as mini pills. No side effects.

import { normalizeToShortUrl } from '../services/recent-binders.js';

/** "Wants 1 card" / "Wants 3 cards" - the pill's text. */
export function pillLabel(count) {
  return `Wants ${count} ${count === 1 ? 'card' : 'cards'}`;
}

/** "1 card" / "3 cards" - the per-binder mini pill in the modal. */
export function miniPillLabel(count) {
  return `${count} ${count === 1 ? 'card' : 'cards'}`;
}

/**
 * Pill iff the overlap has loaded with a wanter and at least one card, and
 * the view is not in trade mode (VISUALS.md "Want Overlap Pill"). Anything
 * else - loading, absent, the gated empty shape, zero - is the plain button.
 * @param {import('../types.js').WantOverlap | null | undefined} overlap
 * @param {boolean} inTradeMode
 */
export function shouldShowOverlapPill(overlap, inTradeMode) {
  if (inTradeMode || !overlap || !overlap.wanter) return false;
  return (overlap.cardCount ?? 0) >= 1;
}

function key(url) {
  return (normalizeToShortUrl(url) || '').toLowerCase();
}

/**
 * The Propose Trade modal's list: the viewer's claimed binders minus the one
 * being viewed, each carrying `overlapCount` (0 when the wanter wants nothing
 * it holds). Binders with a count sort first, highest first; the rest keep
 * their original order. Returns new objects; never mutates.
 * @param {{ url: string, name?: string, owner?: string }[]} claimed
 * @param {{ binderUrl: string, cardCount: number }[]} overlapBinders
 * @param {string} currentBinderUrl
 */
export function annotateClaimedBinders(claimed, overlapBinders, currentBinderUrl) {
  const current = key(currentBinderUrl);
  const counts = new Map((overlapBinders || []).map((b) => [key(b.binderUrl), b.cardCount || 0]));
  const rows = (claimed || [])
    .filter((b) => key(b.url) !== current)
    .map((b, index) => ({ ...b, overlapCount: counts.get(key(b.url)) || 0, index }));
  rows.sort((a, b) => b.overlapCount - a.overlapCount || a.index - b.index);
  return rows.map(({ index: _index, ...rest }) => rest);
}
